module.exports = __webpack_public_path__ + "static/media/commission.f1ccac8b.svg";